import { useParams } from '@atlassian/mpac-ui';
import React from 'react';
import TabHeader from "../../../common/components/Tabs/TabHeader";
import ErrorPage from "./Common/ErrorPage";
import ReportsFilters from "./ReportsFilters";
import SalesReports from "./SalesReports";
const reportsComponents = {
  sales: SalesReports
};

const PartnerReports = ({
  mpacBaseUrl,
  partnerId
}) => {
  const {
    reportName
  } = useParams();
  if (!reportName || !Object.keys(reportsComponents).includes(reportName)) return /*#__PURE__*/React.createElement(ErrorPage, null);
  const SelectedComponent = reportsComponents[reportName];
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TabHeader, {
    headerText: "Reports"
  }), /*#__PURE__*/React.createElement(ReportsFilters, null), /*#__PURE__*/React.createElement(SelectedComponent, {
    mpacBaseUrl: mpacBaseUrl,
    partnerId: partnerId
  }));
};

export default PartnerReports;